import { ChargeGrouping, EstimateCharge } from "../estimate"

export interface EstimateOutputBase {
  total: number
  totalBillableToPatient: number
  discountApplied: number
  discountPercentage?: number
  cptDiscountApplied: number
  charityCareDiscountApplied?: number
  deductibleApplied: number
  coinsuranceApplied: number
  copaymentApplied: number
  outOfPocketMaxApplied: number | null
  insuranceResponsibility: number
  secondaryInsuranceResponsibility?: number
  patientsResponsibility: number
}

export interface EstimateVisitOutput extends EstimateOutputBase, ChargeGrouping {
  appointmentId?: string
  dateOfService?: string
  charges: EstimateCharge[]
  pricerError?: string
}

export interface EstimateWarning {
  code: 'EMPTY_VISIT'
  visitNumber: number
}

export interface EstimateOutput extends EstimateOutputBase {
  message?: string
  missingData?: boolean
  visits: EstimateVisitOutput[]
  warnings?: EstimateWarning[]
  pricerStatus?: EstimateOutput.PRICER_STATUS
  pricerErrors?: string[]
}

export namespace EstimateOutput {
  export enum PRICER_STATUS {
    SUCCESS = 'success',
    PARTIAL_ERRORS = 'partial_errors',
    FAILED = 'failed',
  }
}
